import React, { forwardRef } from "react";

const TooltipProvider = ({ children }) => {
  return <div className="tooltip-provider">{children}</div>;
};

const Tooltip = ({ children }) => {
  return <div className="tooltip-root group">{children}</div>;
};

const TooltipTrigger = ({ children, onMouseEnter, onMouseLeave }) => {
  return (
    <div
      className="tooltip-trigger"
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      {children}
    </div>
  );
};

const TooltipContent = forwardRef(({ className, sideOffset = 4, children }, ref) => (
  <div
    ref={ref}
    className={`${className || ""} tooltip-content z-50 overflow-hidden rounded-md border bg-popover px-3 py-1.5 text-sm text-popover-foreground shadow-md transition-opacity`}
    style={{ marginTop: sideOffset }}
  >
    {children}
  </div>
));
TooltipContent.displayName = "TooltipContent";

export { Tooltip, TooltipTrigger, TooltipContent, TooltipProvider };
